(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plot-product-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('plot-product-layout')) {
    customElements.define('plot-product-layout', class extends HTMLElement {
      async connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        await customElements.whenDefined('media-gallery');
        if (!this.isConnected) return;
        this.gallery = this.productInfo.querySelector('media-gallery');
        this.thumbnails = this.gallery?.querySelector('[id^="GalleryThumbnails-"]');
        if (!this.thumbnails) return;
        this.append(this.thumbnails);
        this.refresh = this.refresh.bind(this);
        this.productInfo.addEventListener('plot:variant-change', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('plot:variant-change', this.refresh);
      }

      refresh() {
        const picker = this.productInfo.querySelector('variant-selects');
        const choices = Array.from(picker?.querySelectorAll('.plot-color-input') || []);
        const selected = choices.find((choice) => choice.checked);
        const label = this.productInfo.querySelector('[data-plot-selected-color]');
        if (label) label.textContent = selected?.value || '';
        this.style.setProperty('--plot-thumb-size', picker?.style.getPropertyValue('--plot-color-image-size') || '42px');
        const list = this.thumbnails.querySelector('.thumbnail-list');
        if (!list) return;
        const items = Array.from(list.querySelectorAll('[data-target]'));
        const assigned = new Set();
        let hasEveryColor = true;
        let columns = Math.max(choices.length, 1);
        choices.forEach((choice, column) => {
          const ids = choice.dataset.colorMediaIds?.split(',').filter(Boolean) || [];
          const matches = ids.map((id) => items.find((item) => item.dataset.target.endsWith('-' + id))).filter(Boolean);
          if (!matches.length) hasEveryColor = false;
          matches.forEach((item, row) => {
            if (assigned.has(item)) return;
            assigned.add(item);
            item.style.gridColumn = column + 1;
            item.style.gridRow = row + 1;
            item.classList.toggle('plot-color-primary', row === 0);
            item.classList.toggle('plot-color-selected', choice.checked);
            const button = item.querySelector('button');
            button.setAttribute('aria-label', this.dataset.photoLabel.replace('__COLOR__', choice.value).replace('__INDEX__', row + 1));
            button.title = choice.value;
            list.append(item);
          });
        });
        items.filter((item) => !assigned.has(item)).forEach((item) => {
          item.style.gridColumn = ++columns;
          item.style.gridRow = 1;
          item.classList.add('plot-color-primary');
          list.append(item);
        });
        this.style.setProperty('--plot-thumb-columns', columns);
        this.productInfo.classList.add('plot-layout-ready');
        this.productInfo.classList.toggle('plot-colors-mapped', choices.length > 0 && hasEveryColor && picker.dataset.gallerySelectsColor === 'true');
        this.thumbnails.resetPages?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const thumbnail = event.target.closest('.thumbnail');
    if (!thumbnail) return;
    const target = thumbnail.closest('[data-target]')?.dataset.target;
    const productInfo = thumbnail.closest('product-info');
    const picker = productInfo?.querySelector('variant-selects');
    if (!target || !picker || picker.dataset.gallerySelectsColor !== 'true') return;
    const mediaId = target.split('-').pop();
    const matches = Array.from(picker.querySelectorAll('.plot-color-input[data-color-media-ids]'))
      .filter((input) => input.dataset.colorMediaIds.split(',').includes(mediaId));
    if (matches.length !== 1) return;
    const choice = matches[0];
    if (!choice.checked) {
      productInfo.dataset.plotColorMediaTarget = mediaId;
      choice.click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
